<template>
  <div id="list-header-wrapper">
    <div class="results-count-wrapper">
      <div class="results-count">
        Showing results for:
        <span class="bold">{{ gardens.length }}</span>
        gardens<span v-if="locationName"> near <span class="bold">{{ locationName }}</span></span>
      </div>
    </div>
    <div class="d-none d-xl-flex align-items-center">
      Sort by: <SortButton class="ml-2 sort-button-component"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SortButton from '@/components/gardenList/SortButton'

export default {
  name: 'ListHeader',

  components: {
    SortButton,
  },

  computed: {
    ...mapGetters('garden', [
      'gardens',
    ]),

    ...mapGetters('location', [
      'selectedLocation',
    ]),

    locationName() {
      return this.selectedLocation?.formatted_address || ''
    },
  },
}
</script>

<style scoped lang="scss">
#list-header-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: $color-text-dark;
  font-size: 16px;
  font-weight: 600;
  line-height: normal;

  .bold {
    font-weight: 700;
  }

  @include media-breakpoint-down(md) {
    padding: 0.5rem 1rem;
  }
}
</style>
